/* =============================================================================
   Shade by Shahd — theme.js
   Vanilla JS only. No framework, no animation library.
   Modules: overlays (focus-trapped), sticky header, accordions, cart AJAX,
   quick add, variant picker, predictive search, sticky purchase bar.
   ============================================================================= */
(function () {
  'use strict';

  var routes = window.SBS_ROUTES || {};
  var strings = window.SBS_STRINGS || {};
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents, window.SBS_MONEY_FORMAT);
    return (cents / 100).toFixed(2);
  }

  // Keep purchase controls above Shopify's optional preview toolbar.
  var previewFrame;
  function syncPreviewInset() {
    var frame = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame');
    if (frame && frame !== previewFrame) {
      previewFrame = frame;
      new ResizeObserver(syncPreviewInset).observe(frame);
      new MutationObserver(syncPreviewInset).observe(frame, {attributes:true, attributeFilter:['style','class','hidden']});
    }
    var rect = frame && frame.getBoundingClientRect();
    var inset = rect && rect.height > 0 && rect.top < innerHeight && getComputedStyle(frame).display !== 'none' ? Math.max(0, innerHeight - rect.top) : 0;
    document.documentElement.style.setProperty('--preview-bottom', Math.min(inset, 180) + 'px');
  }
  new MutationObserver(syncPreviewInset).observe(document.body, {childList:true});
  window.addEventListener('resize', syncPreviewInset);
  window.addEventListener('load', syncPreviewInset);
  syncPreviewInset();

  /* --------------------------------------------------------------- overlays */
  var Overlay = {
    open: null,
    lastFocus: null,
    show: function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      Overlay.hide();
      Overlay.lastFocus = document.activeElement;
      el.setAttribute('data-open', 'true');
      document.documentElement.style.overflow = 'hidden';
      Overlay.open = el;
      var first = $('[data-predictive-input]', el) || $(FOCUSABLE, el);
      if (first) first.focus();
    },
    hide: function () {
      if (!Overlay.open) return;
      Overlay.open.setAttribute('data-open', 'false');
      Overlay.open = null;
      document.documentElement.style.overflow = '';
      if (Overlay.lastFocus && Overlay.lastFocus.focus) Overlay.lastFocus.focus();
      Overlay.lastFocus = null;
    },
    trap: function (e) {
      if (!Overlay.open) return;
      if (e.key === 'Escape') { e.preventDefault(); Overlay.hide(); return; }
      if (e.key !== 'Tab') return;
      var items = $$(FOCUSABLE, Overlay.open).filter(function (n) { return n.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  document.addEventListener('keydown', Overlay.trap);
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-overlay-open]');
    if (openBtn) { e.preventDefault(); Overlay.show(openBtn.getAttribute('data-overlay-open')); return; }
    if (e.target.closest('[data-overlay-close]') || e.target.classList.contains('overlay__scrim')) {
      e.preventDefault(); Overlay.hide();
    }
  });

  /* --------------------------------------------------- sticky header (96>64) */
  /* Shrink when the header actually pins, not at a guessed scroll depth. The announcement bar above it is
     not sticky, so the header reaches the top at roughly its height (~35px) - the old `scrollY > 120` left
     it pinned at full height for another ~85px and then jumped, which read as a glitch. Reading the rect
     needs no constants and holds at every breakpoint and any announcement-bar height. */
  var header = $('[data-header]');
  if (header && !header.classList.contains('sbs-hdr--static')) {
    var stuck = false;
    var onScroll = function () {
      var next = header.getBoundingClientRect().top <= 0;
      if (next !== stuck) { stuck = next; header.classList.toggle('is-stuck', stuck); }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ------------------------------------------------------------- mega menu */
  var mega = $('[data-mega]');
  var megaTrigger = $('[data-mega-trigger]');
  if (mega && megaTrigger) {
    var timer;
    var openMega = function () { mega.setAttribute('data-open', 'true'); megaTrigger.setAttribute('aria-expanded', 'true'); };
    var closeMega = function () { mega.setAttribute('data-open', 'false'); megaTrigger.setAttribute('aria-expanded', 'false'); };
    megaTrigger.addEventListener('mouseenter', function () { timer = setTimeout(openMega, 120); });
    megaTrigger.addEventListener('focus', openMega);
    megaTrigger.addEventListener('mouseleave', function () { clearTimeout(timer); });
    if (header) {
      header.addEventListener('mouseleave', closeMega);
      header.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });
    }
  }

  /* ------------------------------------------------------------ accordions */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-accordion-btn]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    if (panel) panel.hidden = open;
    var icon = $('[data-accordion-icon]', btn);
    if (icon) icon.textContent = open ? '+' : '\u2212';
  });

  /* Footer columns: accordion below 768, always open above. */
  var mqDesktop = window.matchMedia('(min-width:768px)');
  function syncFooter() {
    $$('[data-footer-col]').forEach(function (col) {
      var open = mqDesktop.matches;
      col.setAttribute('data-open', String(open));
      var toggle = $('[data-footer-toggle]', col);
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
    });
  }
  syncFooter();
  if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', syncFooter);
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-footer-toggle]');
    if (!t || mqDesktop.matches) return;
    var col = t.closest('[data-footer-col]');
    var open = col.getAttribute('data-open') === 'true';
    col.setAttribute('data-open', String(!open));
    t.setAttribute('aria-expanded', String(!open));
  });

  /* ---------------------------------------------------------- quantity UI */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = $('input', btn.parentNode);
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = btn.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------- toast */
  function toast(message, tone) {
    var existing = $('.toast');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.className = 'toast notice notice--' + (tone || 'success');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 4000);
  }

  /* ------------------------------------------------------------- cart AJAX */
  function refreshCart() {
    return fetch(routes.cart_url + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('#shopify-section-cart-drawer', doc);
        var target = $('[data-cart-drawer-content]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; n.closest('a')?.setAttribute('aria-label', 'Shopping Bag (' + cart.item_count + ')'); });
        return cart;
      });
  }

  function addToCart(id, quantity, button) {
    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    return fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || strings.cart_error);
        return refreshCart().then(function () {
          Overlay.show('CartDrawer');
          toast(strings.added_to_cart || 'Added to bag', 'success');
        });
      })
      .catch(function (err) { toast(err.message || strings.cart_error || 'Could not add to bag', 'error'); })
      .finally(function () { if (button) { button.classList.remove('is-loading'); button.disabled = false; } });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.getAttribute('data-quick-add'), 1, btn);
  });

  function changeLine(key, quantity, row) {
    if (row) row.style.opacity = '.5';
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { if (!r.ok) throw new Error('Bag update failed'); return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { if (window.SBS_ON_CART_PAGE) window.location.reload(); })
      .catch(function () { toast(strings.cart_error || 'Could not update your bag', 'error'); })
      .finally(function () { if (row) row.style.opacity = ''; });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-cart-remove'), 0, rm.closest('.cart-item')); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-cart-qty'), parseInt(input.value, 10) || 1, input.closest('.cart-item'));
  });

  /* ------------------------------------------------------- variant picker */
  function initVariantPicker(root) {
    var dataEl = $('[data-variant-json]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = $('form', $('[data-product-form]', root) || root);
    var idInput = form ? $('[name="id"]', form) : null;
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare-price]', root);
    var skuEl = $('[data-sku]', root);
    var nameEl = $('[data-shade-name]', root);
    var liveEl = $('[data-variant-live]', root);
    var addBtn = $('[data-add-to-cart]', root);
    var stockEl = $('[data-stock]', root);
    var stickyBtn = $('[data-sticky-add]');
    var stickyShade = $('[data-sticky-shade]');
    var stickyPrice = $('[data-sticky-price]');

    function apply(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = money(variant.compare_at_price); compareEl.hidden = false;
          if (priceEl) priceEl.classList.add('t-price--sale');
        } else { compareEl.hidden = true; if (priceEl) priceEl.classList.remove('t-price--sale'); }
      }
      if (skuEl) skuEl.textContent = variant.sku || '';
      if (nameEl) nameEl.textContent = variant.title;
      if (liveEl) liveEl.textContent = (strings.selected_shade || 'Selected shade') + ': ' + variant.title;

      if (stockEl) {
        stockEl.className = 'stock ' + (variant.available ? 'stock--in' : 'stock--out');
        stockEl.querySelector('[data-stock-label]').textContent =
          variant.available ? (strings.in_stock || 'In stock') : (strings.sold_out || 'Sold out');
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? (strings.add_to_cart || 'Add to bag') + ' \u2014 ' + money(variant.price).replace(/<[^>]*>/g, '')
          : (strings.sold_out || 'Sold out');
      }
      /* The sticky bar always mirrors the SAME variant as the main form. */
      if (stickyBtn) {
        stickyBtn.setAttribute('data-variant-id', variant.id);
        stickyBtn.disabled = !variant.available;
      }
      if (stickyShade) stickyShade.textContent = variant.title;
      if (stickyPrice) stickyPrice.innerHTML = money(variant.price);

      /* Variant-driven media */
      if (variant.featured_media && variant.featured_media.id) {
        var thumb = $('[data-media-id="' + variant.featured_media.id + '"]', root);
        if (thumb) thumb.click();
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    var variantSelect = $('[data-variant-select]', root);
    if (variantSelect) variantSelect.addEventListener('change', function () { apply(variants.find(function (v) { return String(v.id) === variantSelect.value; })); });

    $$('[data-swatch]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-available') === 'false' && btn.getAttribute('data-allow-select') !== 'true') return;
        $$('[data-swatch]', root).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var id = parseInt(btn.getAttribute('data-variant-id'), 10);
        apply(variants.filter(function (v) { return v.id === id; })[0]);
      });
    });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        addToCart(stickyBtn.getAttribute('data-variant-id'), parseInt(($('[name="quantity"]', form) || {}).value, 10) || 1, stickyBtn);
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var qty = parseInt(($('[name="quantity"]', form) || {}).value, 10) || 1;
        addToCart(idInput.value, qty, addBtn);
      });
    }
  }
  $$('[data-product-root]').forEach(initVariantPicker);

  /* -------------------------------------------------------- product media */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-media-id]');
    if (!thumb) return;
    var root = thumb.closest('[data-gallery]');
    var stage = $('[data-gallery-stage] img', root);
    var img = $('img', thumb);
    if (stage && img) { stage.src = img.getAttribute('data-large') || img.src; stage.alt = img.alt; }
    $$('[data-media-id]', root).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
    thumb.setAttribute('aria-current', 'true');
  });

  /* ------------------------------------------------- sticky purchase bar */
  var stickyBar = $('[data-sticky-bar]');
  if (stickyBar) {
    var anchor = $('[data-cro-buy-now]') || $('[data-product-form]') || $('[data-sticky-anchor]');
    var onScrollBar = function () {
      var y = anchor ? anchor.getBoundingClientRect().bottom : 420;
      var visible = y <= 0;
      stickyBar.classList.toggle('is-visible', visible);
      stickyBar.inert = !visible;
    };
    onScrollBar();
    window.addEventListener('scroll', onScrollBar, { passive: true });
    window.addEventListener('resize', onScrollBar);
    window.addEventListener('load', onScrollBar);
  }

  /* ----------------------------------------------------- predictive search */
  var psForm = $('[data-predictive-form]');
  if (psForm) {
    var input = $('[data-predictive-input]', psForm);
    var results = $('[data-predictive-results]');
    var debounce, searchRequest = 0;
    var catalogNode = $('[data-search-catalog]');
    var catalog = [];
    try { catalog = catalogNode ? JSON.parse(catalogNode.textContent) : []; } catch (_) {}
    function searchStatus(message) {
      var p = document.createElement('p'); p.className = 't-small'; p.textContent = message; results.replaceChildren(p);
    }
    function localMatches(q) {
      var terms = q.toLowerCase().split(/\s+/);
      return catalog.filter(function(p) { var words = p.title.toLowerCase().split(/[^a-z0-9\u0600-\u06ff]+/); return terms.every(function(t) { return words.some(function(w) { return w.indexOf(t) === 0; }); }); }).slice(0, 6);
    }
    function renderMatches(items) {
      results.replaceChildren();
      var heading = document.createElement('p'); heading.className = 'psearch__col-title'; heading.textContent = 'Products'; results.appendChild(heading);
      items.forEach(function(p) {
        var link = document.createElement('a'); link.className = 'psearch__product'; link.href = p.url;
        var img = document.createElement('img'); img.src = p.image; img.alt = p.title; img.width = 64; img.height = 80; link.appendChild(img);
        var title = document.createElement('span'); title.textContent = p.title; title.style.flex = '1'; link.appendChild(title);
        var price = document.createElement('span'); price.className = 't-price'; price.textContent = p.price; link.appendChild(price); results.appendChild(link);
      });
    }
    input.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = input.value.trim();
      var requestId = ++searchRequest;
      if (q.length < 1) { results.innerHTML = ''; return; }
      var matches = localMatches(q);
      if (matches.length) { renderMatches(matches); return; }
      searchStatus(strings.searching || 'Searching\u2026');
      debounce = setTimeout(function () {
        fetch(routes.predictive_search_url + '?q=' + encodeURIComponent(q) +
              '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search',
              { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (requestId !== searchRequest) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = $('[data-predictive-results]', doc);
            results.innerHTML = fresh ? fresh.innerHTML : '';
          })
          .catch(function () { if (requestId !== searchRequest) return; searchStatus(strings.search_error || 'Search is unavailable right now.'); });
      }, 250);
    });
  }

  /* --------------------------------------------- collection filter submit */
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      /* URL-driven: let the browser navigate so back/forward restores state. */
      form.submit();
    });
  });
})();
